<template>
  <!-- gk-list{*} -->
  <div class="dataList">
    <div class="headItem">
      <list-item :item="loadData" index='head' @childOper="onChildOper" :items="datalist" :box="box"></list-item>
    </div>
    <div class="white"></div>
    <list-item :item="item" :order="loadData" :index="index" v-for="(item, index) in datalist" :key='index' :box="box"></list-item>
  </div>
</template>

<script>
  import ListItem from '@/components/ListItem'
  export default {
    props: ['datalist', 'box', 'order'],
    components: {
      ListItem
    },
    data () {
      return {
      }
    },
    created () {
    },
    computed: {
      loadData () {
        if (this.datalist.length === 0 || this.datalist === null) {
          let item = {
            '无匹配数据': '无匹配数据' 
          }
          return item
        } else {
          if (this.order === 'none') {
            return this.datalist[0]
          } else {
            return this.order
          }
        }
      }
    },
    methods: {
      onChildOper(data) {
        switch (data.from) {
          case 'listItem':
            switch (data.oper) {
              case 'sort':
                this.$emit('childOper', data);
                break
            }
            break
        }
      },
    }
  }
</script>
<style scoped>

  .headItem{
    width: 100%;
    position: fixed;
  }
  .white{
    height: 42px;
  }
  
</style>


// WEBPACK FOOTER //
// src/components/DataList.vue